module.exports = __webpack_public_path__ + "media/images/sort_desc-1fc418e3.png";